import { render, staticRenderFns } from "./RouteButtonWithIcon.vue?vue&type=template&id=9dab76b6&scoped=true"
import script from "./RouteButtonWithIcon.vue?vue&type=script&lang=js"
export * from "./RouteButtonWithIcon.vue?vue&type=script&lang=js"
import style0 from "./RouteButtonWithIcon.vue?vue&type=style&index=0&id=9dab76b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab76b6",
  null
  
)

export default component.exports